import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ margin: "auto", background: "none" }}
      width="200"
      height="200"
      display="block"
      preserveAspectRatio="xMidYMid"
      viewBox="0 0 100 100"
    >
      <rect width="5" height="11" x="47.5" y="19.5" rx="2.5" ry="5.5">
        <animate
          attributeName="opacity"
          begin="-0.8184143222506394s"
          dur="0.8695652173913042s"
          keyTimes="0;1"
          repeatCount="indefinite"
          values="1;0"
        ></animate>
      </rect>
      <rect
        width="5"
        height="11"
        x="47.5"
        y="19.5"
        rx="2.5"
        ry="5.5"
        transform="rotate(21.176 50 50)"
      >
        <animate
          attributeName="opacity"
          begin="-0.7672634271099744s"
          dur="0.8695652173913042s"
          keyTimes="0;1"
          repeatCount="indefinite"
          values="1;0"
        ></animate>
      </rect>
      <rect
        width="5"
        height="11"
        x="47.5"
        y="19.5"
        rx="2.5"
        ry="5.5"
        transform="rotate(42.353 50 50)"
      >
        <animate
          attributeName="opacity"
          begin="-0.7161125319693095s"
          dur="0.8695652173913042s"
          keyTimes="0;1"
          repeatCount="indefinite"
          values="1;0"
        ></animate>
      </rect>
      <rect
        width="5"
        height="11"
        x="47.5"
        y="19.5"
        rx="2.5"
        ry="5.5"
        transform="rotate(63.53 50 50)"
      >
        <animate
          attributeName="opacity"
          begin="-0.6649616368286445s"
          dur="0.8695652173913042s"
          keyTimes="0;1"
          repeatCount="indefinite"
          values="1;0"
        ></animate>
      </rect>
      <rect
        width="5"
        height="11"
        x="47.5"
        y="19.5"
        rx="2.5"
        ry="5.5"
        transform="rotate(84.706 50 50)"
      >
        <animate
          attributeName="opacity"
          begin="-0.6138107416879796s"
          dur="0.8695652173913042s"
          keyTimes="0;1"
          repeatCount="indefinite"
          values="1;0"
        ></animate>
      </rect>
      <rect
        width="5"
        height="11"
        x="47.5"
        y="19.5"
        rx="2.5"
        ry="5.5"
        transform="rotate(105.882 50 50)"
      >
        <animate
          attributeName="opacity"
          begin="-0.5626598465473146s"
          dur="0.8695652173913042s"
          keyTimes="0;1"
          repeatCount="indefinite"
          values="1;0"
        ></animate>
      </rect>
      <rect
        width="5"
        height="11"
        x="47.5"
        y="19.5"
        rx="2.5"
        ry="5.5"
        transform="rotate(127.059 50 50)"
      >
        <animate
          attributeName="opacity"
          begin="-0.5115089514066496s"
          dur="0.8695652173913042s"
          keyTimes="0;1"
          repeatCount="indefinite"
          values="1;0"
        ></animate>
      </rect>
      <rect
        width="5"
        height="11"
        x="47.5"
        y="19.5"
        rx="2.5"
        ry="5.5"
        transform="rotate(148.235 50 50)"
      >
        <animate
          attributeName="opacity"
          begin="-0.46035805626598464s"
          dur="0.8695652173913042s"
          keyTimes="0;1"
          repeatCount="indefinite"
          values="1;0"
        ></animate>
      </rect>
      <rect
        width="5"
        height="11"
        x="47.5"
        y="19.5"
        rx="2.5"
        ry="5.5"
        transform="rotate(169.412 50 50)"
      >
        <animate
          attributeName="opacity"
          begin="-0.4092071611253197s"
          dur="0.8695652173913042s"
          keyTimes="0;1"
          repeatCount="indefinite"
          values="1;0"
        ></animate>
      </rect>
      <rect
        width="5"
        height="11"
        x="47.5"
        y="19.5"
        rx="2.5"
        ry="5.5"
        transform="rotate(190.588 50 50)"
      >
        <animate
          attributeName="opacity"
          begin="-0.35805626598465473s"
          dur="0.8695652173913042s"
          keyTimes="0;1"
          repeatCount="indefinite"
          values="1;0"
        ></animate>
      </rect>
      <rect
        width="5"
        height="11"
        x="47.5"
        y="19.5"
        rx="2.5"
        ry="5.5"
        transform="rotate(211.765 50 50)"
      >
        <animate
          attributeName="opacity"
          begin="-0.3069053708439898s"
          dur="0.8695652173913042s"
          keyTimes="0;1"
          repeatCount="indefinite"
          values="1;0"
        ></animate>
      </rect>
      <rect
        width="5"
        height="11"
        x="47.5"
        y="19.5"
        rx="2.5"
        ry="5.5"
        transform="rotate(232.941 50 50)"
      >
        <animate
          attributeName="opacity"
          begin="-0.2557544757033248s"
          dur="0.8695652173913042s"
          keyTimes="0;1"
          repeatCount="indefinite"
          values="1;0"
        ></animate>
      </rect>
      <rect
        width="5"
        height="11"
        x="47.5"
        y="19.5"
        rx="2.5"
        ry="5.5"
        transform="rotate(254.118 50 50)"
      >
        <animate
          attributeName="opacity"
          begin="-0.20460358056265984s"
          dur="0.8695652173913042s"
          keyTimes="0;1"
          repeatCount="indefinite"
          values="1;0"
        ></animate>
      </rect>
      <rect
        width="5"
        height="11"
        x="47.5"
        y="19.5"
        rx="2.5"
        ry="5.5"
        transform="rotate(275.294 50 50)"
      >
        <animate
          attributeName="opacity"
          begin="-0.1534526854219949s"
          dur="0.8695652173913042s"
          keyTimes="0;1"
          repeatCount="indefinite"
          values="1;0"
        ></animate>
      </rect>
      <rect
        width="5"
        height="11"
        x="47.5"
        y="19.5"
        rx="2.5"
        ry="5.5"
        transform="rotate(296.47 50 50)"
      >
        <animate
          attributeName="opacity"
          begin="-0.10230179028132992s"
          dur="0.8695652173913042s"
          keyTimes="0;1"
          repeatCount="indefinite"
          values="1;0"
        ></animate>
      </rect>
      <rect
        width="5"
        height="11"
        x="47.5"
        y="19.5"
        rx="2.5"
        ry="5.5"
        transform="rotate(317.647 50 50)"
      >
        <animate
          attributeName="opacity"
          begin="-0.05115089514066496s"
          dur="0.8695652173913042s"
          keyTimes="0;1"
          repeatCount="indefinite"
          values="1;0"
        ></animate>
      </rect>
      <rect
        width="5"
        height="11"
        x="47.5"
        y="19.5"
        rx="2.5"
        ry="5.5"
        transform="rotate(338.824 50 50)"
      >
        <animate
          attributeName="opacity"
          begin="0s"
          dur="0.8695652173913042s"
          keyTimes="0;1"
          repeatCount="indefinite"
          values="1;0"
        ></animate>
      </rect>
    </svg>
  );
}

export default Icon;
